import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";
import { JobFunctionFormFields } from "../_components/job-function-form-fields";

export function CreateView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const pageTitle = t("masterdata:CreateJobFunction");
  const pageSubtitle = t("common:CompleteRequiredInformationDescription");

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <JobFunctionFormFields />
    </CenteredLayout>
  );
}
